import { Tab, Tabs } from "@mui/material";
import Card from "@mui/material/Card";
import { dashboardEventListApi } from "Apis/dashboard";
import { dashboardBookingListApi } from "Apis/dashboard";
import colors from "assets/theme/base/colors";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineItem from "examples/Timeline/TimelineItem";
import { useContext, useEffect, useState } from "react";
import { IoCalendar } from "react-icons/io5";
import { MdEvent } from "react-icons/md";
import { Link } from "react-router-dom";
import { MdArrowForward } from "react-icons/md";
import styled from "@emotion/styled";
import { FaRegCalendar } from "react-icons/fa";
import { LoginFormContext } from "context/LoginFormContext";
const { info } = colors;

const ViewLink = styled(Link)`
  color: ${info.main};
  text-decoration: none;
  &:hover {
    text-decoration: underline !important;
  }
`;

function OrdersOverview() {
  const [bookingData, setBookingData] = useState([]);
  const [bookingCount, setBookingCount] = useState(0);
  const [eventData, setEventData] = useState([]);
  const [eventCount, setEventCount] = useState(0);
  const { modules } = useContext(LoginFormContext);
  const { sideNav } = colors;

  const bookingListData = async () => {
    const response = await dashboardBookingListApi();
    setBookingCount(response?.data?.data?.count);
    setBookingData(response?.data?.data?.rows);
  };

  const eventListData = async () => {
    const response = await dashboardEventListApi();
    setEventCount(response?.data?.data?.count);
    setEventData(response?.data?.data?.rows);
  };

  useEffect(() => {
    bookingListData();
    eventListData();
  }, []);

  const [tabValue, setTabValue] = useState("");

  useEffect(() => {
    if (!tabValue && modules?.length > 0) {
      const allowedModules = modules.filter((module) => module.permissions?.read_access);
      if (allowedModules.length > 0) {
        setTimeout(() => {
          if (allowedModules.some((module) => module?.name === "Event")) {
            setTabValue("event");
          } else if (allowedModules.some((module) => module?.name === "Booking")) {
            setTabValue("booking");
          }
        }, 100);
      }
    }
  }, [modules, tabValue]);

  const handleChange = (event, newValue) => {
    if (newValue === "booking") {
      bookingListData();
    } else if (newValue === "event") {
      eventListData();
    }
    setTabValue(newValue);
  };

  const dataToDisplay = tabValue === "booking" ? bookingData : eventData;

  return (
    <Card
      sx={{
        paddingBottom: "40px",
      }}
    >
      <MDBox pt={3} px={3} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <MDBox sx={{ width: "100%" }}>
          <Tabs onChange={handleChange} value={tabValue} aria-label="secondary tabs example">
            {modules.map((module) => {
              if (module?.name === "Booking" && module.permissions?.read_access) {
                return <Tab value="booking" label="Bookings" />;
              }
              if (module?.name === "Event" && module.permissions?.read_access) {
                return <Tab value="event" label="Events" />;
              }
            })}
          </Tabs>
        </MDBox>
      </MDBox>

      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium" color={sideNav.textColor}>
          Upcoming {tabValue} scheduled for this month.
        </MDTypography>
        <MDBox
          mt={0}
          lineHeight="20px"
          sx={{
            paddingTop:
              (tabValue === "booking" && bookingCount > 0) ||
              (tabValue === "event" && eventCount > 0)
                ? "unset"
                : "0px",
          }}
        >
          <MDBox
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "4px",
            }}
            color={sideNav.hoverTextColor}
          >
            {tabValue === "booking" && bookingCount > 0 ? (
              <>
                <MDBox fontSize="16px" fontWeight="900" color={sideNav.hoverTextColor}>
                  {bookingCount}
                </MDBox>{" "}
                <MDBox fontSize="16px" fontWeight="400" color={sideNav.hoverTextColor}>
                  bookings are scheduled for this month.
                </MDBox>
              </>
            ) : tabValue === "event" && eventCount > 0 ? (
              <>
                <MDBox fontSize="16px" fontWeight="900" color={sideNav.hoverTextColor}>
                  {eventCount}
                </MDBox>{" "}
                <MDBox fontSize="16px" fontWeight="400" color={sideNav.hoverTextColor}>
                  events are scheduled for this month.
                </MDBox>
              </>
            ) : (
              <MDBox
                color={sideNav.textColor}
                fontWeight="500"
                fontSize="20px"
                style={{
                  width: "100%",
                  display: "block",
                  textAlign: "center",
                  padding: "100px 0px 50px",
                }}
              >
                No records found!
              </MDBox>
            )}
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox>
        {dataToDisplay?.slice(0, 3)?.map((data) => (
          <MDBox p={2} key={data?.id}>
            <TimelineItem
              color="success"
              icon={tabValue === "booking" ? <FaRegCalendar /> : <MdEvent />}
              title={data?.title}
              startDate={data?.start_date}
              endDate={data?.end_date}
              startTime={data?.start_time}
              endTime={data?.end_time}
            />
          </MDBox>
        ))}
      </MDBox>

      {dataToDisplay?.length > 0 && (
        <MDBox pt={3} display="flex" justifyContent="flex-end" alignItems="center" height="100%">
          <MDTypography
            variant="h6"
            fontWeight="medium"
            sx={{
              fontSize: "14px",
              lineHeight: "16px",
              paddingRight: "10px",
              position: "absolute",
              bottom: "15px",
            }}
          >
            {tabValue === "booking" ? (
              <ViewLink to="/booking" style={{ display: "flex", alignItems: "center" }}>
                View all bookings <MdArrowForward style={{ marginLeft: "5px" }} />
              </ViewLink>
            ) : (
              <ViewLink to="/events" style={{ display: "flex", alignItems: "center" }}>
                View all events <MdArrowForward style={{ marginLeft: "5px" }} />
              </ViewLink>
            )}
          </MDTypography>
        </MDBox>
      )}
    </Card>
  );
}

export default OrdersOverview;
